// export const PRIMARY = '#2a4171'; // Dark blue
export const PRIMARY = '#1D2229'; // Off-black
export const DARK_ACCENT = '#fe6c61'; // Light red
export const LIGHT_ACCENT = '#dbe4ef'; // Light grey
